var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAckodriveElectricVehicle = function SvgAckodriveElectricVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#394A64",
    strokeWidth: 1.5,
    d: "M12 15.502A4.003 4.003 0 0 1 7.997 11.5V8.498a1 1 0 0 1 1.001-1h6.004a1 1 0 0 1 1 1V11.5A4.003 4.003 0 0 1 12 15.502Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#394A64",
    strokeWidth: 1.5,
    d: "M9.999 14.967V16.5a1 1 0 0 0 1 1h2.002a1 1 0 0 0 1-1v-1.534M9.999 7.497V4.495M14.001 7.497V4.495M12 17.503v2.002"
  })));
};
export default SvgAckodriveElectricVehicle;